import { OpsPipelineReconcileComponent } from 'app/components/ops-pipeline-reconcile/OpsPipelineReconcileComponent'
import { useOpsPipelineReconcile } from 'app/components/ops-pipeline-reconcile/useOpsPipelineReconcile'

export default function PipelineReconcile(): React.ReactElement {
  const hookData = useOpsPipelineReconcile()
  return <OpsPipelineReconcileComponent {...hookData} />
}
